<template>
	<CtaModal
		:open="open"
		:title="t('extendedAccess.modal.title', { days: ExtendedAccessDurationDays })"
		:message="t('extendedAccess.modal.message')"
		:features="extendedAccessBenefits"
		:confirm-label="t('extendedAccess.modal.start')"
		:dismiss-label="t('extendedAccess.modal.dismiss')"
		:confirm-disabled="extendedAccessStore.isStarting"
		@confirm="start"
		@dismiss="close"
	/>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import CtaModal, { type CtaModalFeature } from "@/components/modals/CtaModal.vue"
import { IconName } from "@/components/icons/registry"
import { useExtendedAccessStore } from "@/stores/extendedAccessStore"
import { useToastStore } from "@/stores/toastStore"

const ExtendedAccessDurationDays = 30

const open = defineModel<boolean>("open", { required: true })

const { t } = useI18n()
const extendedAccessStore = useExtendedAccessStore()
const toastStore = useToastStore()

const extendedAccessBenefits = computed<CtaModalFeature[]>(() => [
	{ key: "parcelReport", label: t("extendedAccess.benefits.parcelReport"), icon: IconName.FileText },
])

function close(): void {
	open.value = false
}

async function start(): Promise<void> {
	if (await extendedAccessStore.start()) {
		toastStore.success("extendedAccess.messages.started")
		close()
	} else {
		toastStore.error("extendedAccess.messages.startError")
	}
}
</script>
